module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/star3.0a0ec00e.png";